import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const FIELD_OPTIONS = [
  { id: 'token_address', label: 'Token Address' },
  { id: 'symbol', label: 'Symbol' },
  { id: 'chain', label: 'Chain' },
];

const TokenIdentifiersSection = ({ onUpdate, boostInput = false }) => {
  const [values, setValues] = useState('');
  const [field, setField] = useState(FIELD_OPTIONS[0].id);
  const [boost, setBoost] = useState(1);

  const handleAction = (actionType) => {
    if (!values.trim()) return;
    const parsedValues = values.split(',').map((v) => v.trim()).filter(Boolean);
    if (parsedValues.length === 0) return;

    const updateData = {
      action: actionType,
      filter: 'terms',
      field,
      value: parsedValues,
    };

    if (boostInput) {
      updateData.boost = boost;
    }

    onUpdate(updateData);
    setValues('');
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Identifier Field</InputLabel>
        <Select
          value={field}
          onChange={(e) => setField(e.target.value)}
          label="Identifier Field"
        >
          {FIELD_OPTIONS.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Values"
        value={values}
        onChange={(e) => setValues(e.target.value)}
        placeholder="Enter comma-separated values"
        helperText="Example: 0x123..., ETH, ethereum"
        fullWidth
        sx={{ mb: 2 }}
      />

      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleAction('include')}
          disabled={!values.trim()}
        >
          <AddIcon />
        </Button>

        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleAction('boost')}
            disabled={!values.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}

        <Button
          variant="contained"
          color="error"
          onClick={() => handleAction('exclude')}
          disabled={!values.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default TokenIdentifiersSection;
